import React from 'react';
import { jwtDecode } from 'jwt-decode';

import AMTable from '../Components/TablesForHomePage/AMTable';
import WorkerTable from '../Components/TablesForHomePage/WorkerTable';

import Loading from '../Components/Loading';

const Home = () => {
  const [userRole, setUserRole] = React.useState('');
  const [nameOfLabel, setNameOfLabel] = React.useState('');

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserRole(decodedToken.role);

      switch (decodedToken.role) {
        case 'Администратор':
        case 'Менеджер':
          setNameOfLabel('Входящая корреспонденция');
          break;
        case 'Работник по назначениям':
          setNameOfLabel('Назначения');
          break;
        case 'Работник по жалобам':
          setNameOfLabel('Жалобы');
          break;
        case 'Работник по общим':
          setNameOfLabel('Общие');
          break;
        case 'Арбитражный управляющий':
          setNameOfLabel('Арбитражный управляющий');
          break;
        default:
          break;
      }
    }
  }, []);


  if (!userRole || !nameOfLabel) {
    return <Loading />;
  }

  return (
    <>
      {userRole === 'Арбитражный управляющий' ? (
        <AMTable />
      ) : (
        <WorkerTable nameOfLabel={nameOfLabel} setNameOfLabel={setNameOfLabel} />
      )}
    </>
  );
};

export default Home;